import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from '@/locales/vuetify_ru'
import kg from '@/locales/vuetify_kg'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { ru, kg },
    current: 'ru'
  }
})
